import { badgeCommonTrackingModule } from '../common/di'

export const badgeTinCanTrackingModules = [
  badgeCommonTrackingModule
]
